import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import MaskedInput from 'react-maskedinput';
import { Label, FormField, FlexForm, InputBox, InputElement, Dpicker, LucDpicker, TextArea, Required } from './styles';
import Loader from '../../../../assets/loader';
import Modal from '../modal';
import * as ModalModules from '../modal/styles';
import Select from '../deprecated-select';
import api from '../../../../_core/api';
import { Multiselect, IOption } from '../select';
import { failure } from '../../../../_core/services/toast';

interface INewNegotiation {
  active?: boolean | undefined;
  closeModalFunction?: any;
  customer?: any;
  userName?: any;
  negotiation?: INegotiation | null;
  edit?: boolean;
}

interface IContactFormFields {
  contactDate?: Date;
  additionalInformation?: string;
  cpfCnpj?: string;
  billingGroupId?: number;
  negotiationReturnId?: number;
  shopping?: string;
  luc?: string;
  brand?: string;
  userIdentifier?: string;
}

interface INegotiation {
  identifier?: number;
  cpfCnpj?: number;
  customerName?: string;
  brand?: string;
  billingGroupId?: number;
  billingGroupName?: string;
  luc?: string;
  shoppingId: number;
  shoppingName?: string;
  contactDate: string;
  negotiationReturnId?: number;
  negotiationReturnName?: string;
  contactResponsible?: string;
  active?: boolean;
  additionalInformation?: string;
}

export const NovaNegociacao: React.FC<INewNegotiation> = ({
  active,
  closeModalFunction,
  customer,
  userName,
  negotiation = null,
  edit = false,
}) => {
  /** States */
  const [modalActive, setModalActive] = useState<boolean | undefined>(false);
  const [startDate] = useState(new Date());
  const [contactFormFields, setContactFormFields] = useState<IContactFormFields>({});
  const [lucSelected, setSelectedLuc] = useState<IOption[]>([]);
  const [isLuc] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean | undefined>(false);
  const filterVazio: IFilter = {
    lucs: [],
    businessGroup: [{ value: '0', label: 'Sem Grupo de Cobrança' }],
  };
  const [filterData, setFilterData] = useState<IFilter>(filterVazio);
  const [negotiationsReturn, setNegotiationsReturn] = useState<OptionsItems[]>([]);

  /** UseEffects */
  useEffect(() => {
    getNegotiationsReturn();
  }, []);

  useEffect(() => {
    setModalActive(active);
    handleChangeField('contactDate', startDate);
  }, [active]);

  function montarFormField(negotiation: INegotiation) {
    const date = new Date(negotiation.contactDate);
    date.setDate(date.getDate() + 1);

    const objetoFormField: IContactFormFields = {
      contactDate: date,
      additionalInformation: negotiation.additionalInformation,
      cpfCnpj: negotiation.cpfCnpj?.toString(),
      billingGroupId: negotiation.billingGroupId,
      negotiationReturnId: negotiation.negotiationReturnId,
      shopping: negotiation.shoppingId.toString(),
      luc: negotiation.luc,
      brand: negotiation.brand,
      userIdentifier: negotiation.contactResponsible,
    };
    setContactFormFields(objetoFormField);
  }

  useEffect(() => {
    if (customer.cpfCnpj) {
      getData({
        shopping: customer.query.shoppingId,
        cpfCnpj: customer.cpfCnpj,
      });
    }

    if (negotiation != null) {
      montarFormField(negotiation);
      pegarLucNegociacao(negotiation.luc);
    }
  }, [customer, negotiation]);

  /** Handle methods */
  const handleExitModal = (inseriu = false) => {
    closeModalFunction(inseriu);
    setModalActive(false);
    setContactFormFields({ additionalInformation: '' } as IContactFormFields);
    setSelectedLuc([]);
    setFilterData(filterVazio);
  };

  const handleChangeField = (field: any, value: any) => {
    const formFields: IContactFormFields = contactFormFields;

    setContactFormFields({ ...formFields, [field]: value });
  };

  /** Interfaces */
  interface IItemFilter {
    brand: string;
    businessGroupId: number;
    businessGroupName: string;
    cnpjCpf: string;
    customerName: string;
    idLuc: number;
    luc: string;
    shoppingId: number;
    shoppingName: string;
  }

  interface OptionsItems {
    value: string;
    label: string;
  }

  interface IFilter {
    brand?: string;
    businessGroupId?: number;
    businessGroupName?: string;
    cnpjCpf?: string;
    customerName?: string;
    idLuc?: number;
    luc?: string;
    shoppingId?: number;
    shoppingName?: string;

    lucs: IOption[];
    businessGroup: OptionsItems[];
  }

  /** Requests methods */
  const getData = async ({ cpfCnpj, shopping }: any) => {
    const response = await api.get(`/filters/siscob-filters-information?shoppingIds=${shopping}&cpfsCnpjs=${cpfCnpj}`);
    const { data } = response;

    // const { data } = await mockapi.get(`filter-information`);

    /** lógica para ter múltiplos itens em LUCS */
    let filter: IFilter = filterData;
    data.map((item: IItemFilter) => {
      const { lucs, businessGroup } = filter;

      if (lucs.filter(l => l.label == item.luc).length > 0) {
      } else {
        lucs.push({ id: item.idLuc, label: item.luc });
      }

      if (item.businessGroupId != null) {
        const verifyItem = businessGroup.find(e => e.value === item.businessGroupId.toString());

        if (verifyItem == null) {
          businessGroup.push({
            value: item.businessGroupId.toString(),
            label: item.businessGroupName,
          });
        }
      }

      filter = { ...filter, lucs, businessGroup };
      filter.businessGroupId = data[0].businessGroupId;
      filter.businessGroupName = data[0].businessGroupName;
      filter.shoppingId = data[0].shoppingId;
      filter.shoppingName = data[0].shoppingName;
      filter.cnpjCpf = data[0].cnpjCpf;
      filter.customerName = data[0].customerName;
      filter.brand = data[0].brand;
      filter.idLuc = data[0].idLuc;
      filter.luc = data[0].luc;
    });

    setFilterData(filter);

    //
    //
    //
    // sethistoryClientData(response.data.data);
  };

  function pegarLucNegociacao(lucNegotiation: any) {
    const lucSelected: IOption[] = [];
    filterData.lucs.map(luc => {
      if (luc.label == lucNegotiation) {
        lucSelected.push(luc);
      }
    });
    setSelectedLuc(lucSelected);
  }

  const getNegotiationsReturn = async () => {
    const { data } = await api.get(`/filters/negotiations-return`);
    const negotiations: OptionsItems[] = negotiationsReturn;
    data.map((item: any) => {
      negotiations.push({
        value: item.returnId.toString(),
        label: item.returnName,
      });
    });
    negotiations.sort((item1, item2) => comparar(item1, item2));
    negotiations.unshift({ value: '0', label: 'Selecione' });
    setNegotiationsReturn(negotiations);
  };

  function comparar(item1: OptionsItems, item2: OptionsItems) {
    if (item1.label > item2.label) return 1;
    if (item1.label < item2.label) return -1;
    return 0;
  }

  function converterData(data: any): string {
    let dia = `${data.getDate()}`;
    let mes = `${data.getMonth() + 1}`;
    const ano = `${data.getFullYear()}`;

    const pad = '00';
    dia = pad.substring(0, pad.length - dia.length) + dia;
    mes = pad.substring(0, pad.length - mes.length) + mes;

    return `${ano}-${mes}-${dia}`;
  }

  const sendData = async () => {
    const dataPost: any = [];
    if (contactFormFields.negotiationReturnId === undefined && lucSelected.length <= 0) {
      failure('Selecione o Retorno da Negociação e uma LUC');
    } else {
      if (contactFormFields.negotiationReturnId !== undefined) {
        if (lucSelected.length > 0) {
          setLoading(true);
          lucSelected.map(luc => {
            dataPost.push({
              contactDate: converterData(contactFormFields.contactDate),
              additionalInformation: contactFormFields.additionalInformation,
              cpfCnpj: filterData.cnpjCpf,
              billingGroupId: filterData.businessGroupId,
              negotiationReturnId: contactFormFields.negotiationReturnId,
              shoppingId: filterData.shoppingId,
              luc: luc.label,
              brand: filterData.brand,
              active: 1,
              userIdentifier: userName,
            });
          });

          const dataPut = {
            contactDate: converterData(contactFormFields.contactDate),
            additionalInformation: contactFormFields.additionalInformation,
            cpfCnpj: filterData.cnpjCpf,
            billingGroupId: filterData.businessGroupId,
            negotiationReturnId: contactFormFields.negotiationReturnId,
            shoppingId: filterData.shoppingId,
            luc: lucSelected[0].label,
            brand: filterData.brand,
            active: 1,
            userIdentifier: userName,
          };

          if (negotiation?.identifier != null) {
            api.put(`/negotiation-history/${negotiation.identifier}`, dataPut).then(
              response => {
                setLoading(false);
                alert('Negociação salva com sucesso!');
                handleExitModal(true);
              },
              error => {
                setLoading(false);
                alert('Ocorreu um erro, tente novamente!');
              },
            );
          } else {
            api.post(`/negotiation-history/negotiation-histories`, dataPost).then(
              response => {
                setLoading(false);
                alert('Negociação salva com sucesso!');
                handleExitModal(true);
              },
              error => {
                setLoading(false);
                alert('Ocorreu um erro, tente novamente!');
              },
            );
          }
        } else {
          failure('Selecione uma LUC');
        }
      } else {
        failure('Selecione o Retorno da Negociação');
      }
    }
  };

  //
  return (
    <Modal active={modalActive}>
      <Draggable>
        {loading ? (
          <div className="loaderUser">
            <Loader />
          </div>
        ) : (
          <ModalModules.Box>
            <ModalModules.Content>
              <FlexForm>
                <FormField>
                  <InputBox>
                    <Label>Shopping</Label>
                    <InputElement
                      hidden
                      name="shoppingId"
                      defaultValue={filterData.shoppingId}
                      onChange={e => {
                        handleChangeField(e.target.name, e.target.value);
                      }}
                      disabled
                    />
                    <InputElement
                      name="shopping"
                      defaultValue={filterData.shoppingName}
                      onChange={e => {
                        handleChangeField(e.target.name, e.target.value);
                      }}
                      disabled
                    />
                  </InputBox>
                </FormField>
                <FormField>
                  <InputBox>
                    <Label>Grupo de Cobrança</Label>
                    <InputElement
                      name="billingGroupId"
                      defaultValue={filterData.businessGroupName}
                      onChange={e => {
                        handleChangeField(e.target.name, e.target.value);
                      }}
                      disabled
                    />
                  </InputBox>
                </FormField>
                <FormField>
                  <Label>Cliente</Label>
                  <InputElement
                    hidden
                    name="cnpjCpf"
                    defaultValue={filterData.cnpjCpf}
                    onChange={e => {
                      handleChangeField(e.target.name, e.target.value);
                    }}
                  />
                  <InputElement
                    name="customerName"
                    defaultValue={filterData.customerName}
                    onChange={e => {
                      handleChangeField(e.target.name, e.target.value);
                    }}
                    disabled
                  />
                </FormField>
                <LucDpicker>
                  <FormField>
                    <Label>
                      LUC
                      {isLuc && <Required>Luc é Obrigatório</Required>}
                    </Label>

                    <Multiselect
                      selectedFromParent={lucSelected}
                      className="luc"
                      onPick={(opcoes: IOption[]) => setSelectedLuc(opcoes)}
                      options={filterData.lucs}
                      updateFromParent
                      singleSelect={edit}
                    />
                  </FormField>
                  <FormField>
                    <Label>Data de contato</Label>
                    <Dpicker
                      selected={contactFormFields.contactDate}
                      required
                      name="contactDate"
                      onChange={(date: any) => handleChangeField('contactDate', date)}
                      dateFormat="dd/MM/yyyy"
                      customInput={<MaskedInput mask="11/11/1111" placeholder="dd/MM/yyyy" />}
                    />
                  </FormField>
                </LucDpicker>
                <FormField>
                  <Label>Nome fantasia</Label>
                  <InputElement
                    name="brand"
                    defaultValue={filterData.brand}
                    onChange={e => {
                      handleChangeField(e.target.name, e.target.value);
                    }}
                    disabled
                  />
                </FormField>
                <FormField>
                  <Select
                    helperClass="select"
                    name="negotiationReturnId"
                    options={negotiationsReturn}
                    selectedValue={contactFormFields.negotiationReturnId}
                    label="Retorno da negociação"
                    onChange={e => {
                      handleChangeField(e.target.name, e.target.value);
                    }}
                  />
                </FormField>
                <FormField>
                  <InputBox>
                    <Label>Descrição da Negociação</Label>
                    <TextArea
                      name="additionalInformation"
                      value={contactFormFields.additionalInformation}
                      onChange={e => {
                        handleChangeField(e.target.name, e.target.value);
                      }}
                    />
                  </InputBox>
                </FormField>
              </FlexForm>
            </ModalModules.Content>
            <ModalModules.Footer>
              <ModalModules.Button type="button" onClick={() => handleExitModal()}>
                Fechar
              </ModalModules.Button>
              <ModalModules.Button filled type="button" onClick={() => sendData()}>
                Enviar
              </ModalModules.Button>
            </ModalModules.Footer>
          </ModalModules.Box>
        )}
      </Draggable>
    </Modal>
  );
};
